(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text-seo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rich-text-seo-expand')) {
    class RichTextSeoExpand extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-seo-content]');
        this.button = this.querySelector('[data-seo-toggle]');
        this.label = this.querySelector('[data-seo-label]');
        if (!this.content || !this.button) return;

        this.lines = Number(this.dataset.lines) || 4;
        this.expanded = false;
        this.toggleable = false;
        this.onToggle = this.onToggle.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);

        this.button.addEventListener('click', this.onToggle);
        this.content.addEventListener('transitionend', this.onTransitionEnd);
        window.addEventListener('resize', this.onResize);

        this.updateOverflow();
        this.classList.add('is-ready');
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
        this.content?.removeEventListener('transitionend', this.onTransitionEnd);
        window.removeEventListener('resize', this.onResize);
      }

      getCollapsedHeight() {
        const clone = this.content.cloneNode(true);
        const width = this.content.getBoundingClientRect().width;
        clone.setAttribute('aria-hidden', 'true');
        clone.style.cssText = [
          'position:absolute',
          'visibility:hidden',
          'pointer-events:none',
          'left:0',
          'top:0',
          'height:auto',
          'max-height:none',
          'overflow:hidden',
          'display:-webkit-box',
          '-webkit-box-orient:vertical',
          '-webkit-line-clamp:' + this.lines,
          'width:' + width + 'px'
        ].join(';');
        this.appendChild(clone);
        const height = clone.getBoundingClientRect().height;
        clone.remove();
        return height;
      }

      updateOverflow() {
        if (this.expanded) return;

        const collapsed = this.getCollapsedHeight();
        const full = this.content.scrollHeight;
        this.toggleable = full > collapsed + 2;
        this.collapsedHeight = collapsed;

        if (!this.toggleable) {
          this.classList.add('is-short');
          this.button.hidden = true;
          this.content.style.height = '';
          return;
        }

        this.classList.remove('is-short');
        this.button.hidden = false;
        this.content.style.height = collapsed + 'px';
      }

      onToggle() {
        if (!this.toggleable) return;
        if (this.expanded) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      expand() {
        const start = this.content.getBoundingClientRect().height;
        this.expanded = true;
        this.classList.add('is-expanded');
        this.button.setAttribute('aria-expanded', 'true');
        if (this.label) this.label.textContent = 'Show less';
        this.content.style.height = start + 'px';
        requestAnimationFrame(() => {
          this.content.style.height = this.content.scrollHeight + 'px';
        });
      }

      collapse() {
        const start = this.content.scrollHeight;
        this.expanded = false;
        this.classList.remove('is-expanded');
        this.button.setAttribute('aria-expanded', 'false');
        if (this.label) this.label.textContent = 'Show more';
        this.content.style.height = start + 'px';
        this.content.offsetHeight;
        requestAnimationFrame(() => {
          this.content.style.height = (this.collapsedHeight || this.getCollapsedHeight()) + 'px';
        });
      }

      onTransitionEnd(event) {
        if (event.propertyName !== 'height' || event.target !== this.content) return;
        if (this.expanded) this.content.style.height = 'auto';
      }

      onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          if (!this.expanded) this.updateOverflow();
        }, 150);
      }
    }

    customElements.define('rich-text-seo-expand', RichTextSeoExpand);
  }

  } catch(e) { console.error(e); }
})();
})();
